import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "@patient-watch/ui/sonner";
import { useToastCopy } from "@/features/i18n/toastCopy";
import { supabaseClient } from "@/lib/supabase";

interface TogglePublishScheduleParams {
    scheduleId: string;
    isPublished: boolean;
}

export async function togglePublishSchedule({ scheduleId, isPublished }: TogglePublishScheduleParams) {
    const { error } = await supabaseClient
        .from("schedules")
        .update({ is_published: isPublished })
        .eq("schedule_id", scheduleId);

    if (error) throw error;

    return { scheduleId, is_published: isPublished };
}

export function useTogglePublishScheduleMutation() {
    const toastCopy = useToastCopy();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: togglePublishSchedule,
        onSuccess: (_data) => {
            toast.success(toastCopy.scheduleUpdatedSuccess);
            queryClient.invalidateQueries({ queryKey: ["schedules"] });
            queryClient.invalidateQueries({ queryKey: ["schedule"] });
        },
        onError: (error) => {
            console.error("Failed to toggle publish status:", error);
            toast.error(toastCopy.failedUpdatePublishStatus);
        },
    });
}
